import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CarouselComponent } from 'src/app/shared/components/carousel/carousel.component';
import { Company } from 'src/app/shared/model/company.model';
import { AppRoutes } from 'src/app/shared/routes/common.routes';
import { AuthStateService } from 'src/app/shared/services/auth/auth-state.service';
import { CompanyService } from 'src/app/shared/services/company/company.service';
import { LogToastService } from 'src/app/shared/services/log-toast/log-toast.service';
import { RegistrationFormComponent } from '../registration-form/registration-form.component';

@Component({
  selector: 'app-registration',
  imports: [CarouselComponent, RegistrationFormComponent],
  templateUrl: './registration.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistrationComponent {
  #companyService = inject(CompanyService);
  #logToast = inject(LogToastService);
  #router = inject(Router);
  #authState = inject(AuthStateService);

  onSuccess(company: Company): void {
    this.#companyService.createCompany(company).subscribe({
      next: (myCompany) => {
        this.#authState.company.set(myCompany);
        this.#authState.userDetails.update((user) => (user ? { ...user, company: myCompany } : null));
        this.#logToast.success('MESSAGES.SUCCESS.COMPANY_CREATED_SUCCESSFULLY', undefined, {
          logger: false,
          toast: true,
        });
        this.#router.navigate([AppRoutes.dashboard]);
      },
      error: (error) => {
        this.#logToast.error('MESSAGES.ERRORS.CREATING_COMPANY', error);
      },
    });
  }
}
